export const experiment = {
  initial: 'getTealiumUserId',
  states: {
    getTealiumUserId: {
      on: {
        ENVIROMENT_USER_ACTION_TRIGGERED: {
          cond: 'isTealiumUserIdNotSet',
          target: 'getTealiumUserIdAfterDelay',
        },
      },
      invoke: {
        src: 'fetchTealiumUserId',
        onDone: {
          actions: [
            {
              type: 'save',
              data: {
                tealiumUserId: '$event.data.tealiumUserId',
              },
              meta: {
                selectors: ['$action.data.tealiumUserId'],
              },
            },
          ],
        },
      },
    },
    getTealiumUserIdAfterDelay: {
      after: {
        2000: {
          target: 'getTealiumUserId',
        },
      },
    },
  },
};
